import React from "react";

import TitleField from '../text/TitleField.js';
import TextField from '../text/TextField.js';


import '../../styles/designs/AdvantageCard.css';


import { FaUserGroup } from "react-icons/fa6";
import { TbTargetArrow } from "react-icons/tb";
import { LuShieldCheck } from "react-icons/lu";

import Reveal from '../motion/Reveal';
import { StaggerGroup, StaggerItem } from '../motion/Stagger';

const AdvantageCard = () => {

    const advantageItems = [

        {
            title: "Direct Communication",
            text: 'You work directly with the developers building your software. No middle layers, no delays, no lost details.',
            icon: FaUserGroup,
        },
        {
            title: "Focused & Efficient",
            text: 'We stay focused on what matters: building the right solution for your community, the right way.',
            icon: TbTargetArrow,
        },
        {
            title: "Long-Term Partnership",
            text: "We're in it for the long run supporting your system, adapting as you grow, and building trust over time.",
            icon: LuShieldCheck,
        },


    ]

    return (
        <>
            <StaggerGroup as="div" className="advantage-card-container" scroll staggerChildren={0.15} amount={0.2}>
                <Reveal as="div" className="advantage-card-title-container">
                    <TitleField title="Why Working With a Small Team Works" bold={true}/>
                </Reveal>
                {advantageItems.map((item, index) => (
                    <StaggerItem as="div" className="advantage-card-item" key={item.title}>
                        <item.icon className="advantage-card-icon"/>

                        <TitleField title={item.title} bold={true}/>

                        <TextField text={item.text} fontColor={'#666666'} fontSize={'0.9rem'}/>

                    </StaggerItem>
                ))}
            </StaggerGroup>
        </>
    )

};

export default AdvantageCard;